export const MY_NAVLINKS = [
  {
    title: 'Авто',
    route: `/my/avto/`,
    slug: 'avto',
  },
  {
    title: 'Мото',
    route: `/my/moto/`,
    slug: 'moto',
  },
  {
    title: 'Автобусы',
    route: `/my/avtobus/`,
    slug: 'avtobus',
  },
  {
    title: 'Грузовики',
    route: `/my/gruzovye/`,
    slug: 'gruzovye',
  },
  {
    title: 'Прицепы',
    route: '/my/pritsepy/',
    slug: 'pritsepy',
  },
  {
    title: 'Водный транспорт',
    route: '/my/vodnyi-transport/',
    slug: 'vodnyi-transport',
  },
  {
    title: 'Спецтехника',
    route: '/my/spetstehnika/',
    slug: 'spetstehnika',
  },
  {
    title: 'Запчасти',
    route: '/my/zapchasti/',
    slug: 'spareparts',
  },
];

export const FAVORITES = [
  {
    title: 'Авто',
    route: `/favorites/avto/`,
  },
  {
    title: 'Мото',
    route: `/favorites/moto/`,
  },
  {
    title: 'Автобусы',
    route: `/favorites/avtobus/`,
  },
  {
    title: 'Грузовики',
    route: `/favorites/gruzovye/`,
  },
  {
    title: 'Спецтехника',
    route: '/favorites/spetstehnika/',
  },
  {
    title: 'Прицепы',
    route: '/favorites/pritsepy/',
  },
];

export const DEALER_TABS = {
  ABOUT: 'about',
  BLOG: 'blog',
  OFFERS: 'offers',
};

export const DEALER_TAB_BTNS = [
  {
    title: 'Предложения',
    tab: DEALER_TABS.OFFERS,
    slug: null,
  },
  {
    title: 'Новости и Акции',
    tab: DEALER_TABS.BLOG,
    slug: DEALER_TABS.BLOG,
  },
  {
    title: 'О компании',
    tab: DEALER_TABS.ABOUT,
    slug: DEALER_TABS.ABOUT,
  },
];

export const DEALER_HEADER = [
  {
    title: 'предложения',
    slug: '',
    scrollTo: 'main-block',
  },
  {
    title: 'новости и акции',
    slug: `blog`,
    scrollTo: 'main-block',
  },
  {
    title: 'о компании',
    slug: `about`,
    scrollTo: 'info-block',
  },
];



// WEBPACK FOOTER //
// ./src/shared/constants/navigation.js